export default __webpack_public_path__ + "static/media/meal-icon.52f492f3.svg";